module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.4a51a7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/AmwayIcons.woff?5v2gxx
// module id = vn6z
// module chunks = 0